export const formatDistance = (kilometers: number, locale?: string) => {
  const isMetric = locale?.toLowerCase() !== 'en_us';
  const mileToKmRatio = 1.60934;
  if (isMetric) return kilometers;
  return Math.round(kilometers * mileToKmRatio * 10) / 10;
};
